import { AccordionPanel } from '../../../../../CommonComponents/OPL/Accordion/AccordionPanel/AccordionPanel';
import styled from '../../../../../theme/theme';

export const StyledAccordionPanel = styled(AccordionPanel)(({ theme }) => ({
  borderRadius: 0,
  borderBottom: `1px solid ${theme.colors.neutral[200]}`,
  backgroundColor: theme.colors.bg,
}));
